import WirePayment from "./WirePayment";

export default WirePayment;
